import { render, staticRenderFns } from "./FooterAppComponent.vue?vue&type=template&id=74cc5e15&scoped=true"
import script from "./FooterAppComponent.vue?vue&type=script&lang=js"
export * from "./FooterAppComponent.vue?vue&type=script&lang=js"
import style0 from "./FooterAppComponent.vue?vue&type=style&index=0&id=74cc5e15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cc5e15",
  null
  
)

export default component.exports